import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LoadingComponent } from "../LoadingComponent/LoadingComponent";
import { GoogleSheetIcon } from "../../assets/icons/GoogleSheetIcon";
import styles from "./ActiveGoogleSheetsContainer.module.scss";
import ScreenHeader from "../ScreenHeader/ScreenHeader";
import Title from "../../ui/Title/Title";
import { ErrorComponent } from "../ErrorComponent/ErrorComponent";
import Button from "../../ui/Button/Button";
import { ClipLoader } from "react-spinners";
import { LinkSlashIcon } from "../../assets/icons/LinkSlashIcon";
import { deactivationGoogleSheets } from "../../utils/api/actions/integrations/googleSheets";

export const ActiveGoogleSheetsContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { activeDataGoogleSheets, isLoadingGoogleSheets, isErrorGoogleSheets } =
    useSelector((state) => state?.googleSheets);
  const { dataAssistants } = useSelector((state) => state?.assistant);

  const assistantName =
    dataAssistants?.find(
      (assistant) => assistant.id === activeDataGoogleSheets.assistantId
    )?.name || "Ассистент не выбран";

  const [loading, setLoading] = useState(false);

  const handleDeactivate = () => {
    let data = {
      assistantId: activeDataGoogleSheets.assistantId,
      withRemove: true,
    };
    dispatch(deactivationGoogleSheets(data, setLoading, navigate));
  };

  const DataItem = ({ title, data, link }) => {
    return (
      <div className={styles.dataItemContainer}>
        <div className={styles.dataItemContainerFlex}>
          <label className={styles.title}>{title}</label>
        </div>
        <label className={styles.data}>
          {link ? (
            <a
              href={data}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.link}
            >
              {data}
            </a>
          ) : (
            data
          )}
        </label>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <ScreenHeader title={"Интеграции"} path={"/integration"} />
      {isLoadingGoogleSheets ? (
        <LoadingComponent />
      ) : (
        <div className={styles.container}>
          <div className={styles.header}>
            <div className={styles.headerInfoContainer}>
              {!isErrorGoogleSheets && (
                <div className={styles.headerInfoContainerTitle}>
                  <Title title={"Google Таблица"} className={styles.title} />
                  <GoogleSheetIcon size={30} />
                </div>
              )}
              {isErrorGoogleSheets && (
                <ErrorComponent
                  title={"Произошла ошибка при получении данных Google Таблиц"}
                  text={
                    "При получении данных произошла ошибка. Вы можете вернуться на страницу интеграций и попробовать открыть страницу еще раз."
                  }
                  buttonTitle={"Вернуться на страницу интеграций"}
                  path={"/integration"}
                />
              )}
              {activeDataGoogleSheets && (
                <Button
                  leftIcon={
                    loading ? (
                      <ClipLoader size={15} color="white" />
                    ) : (
                      <LinkSlashIcon />
                    )
                  }
                  titleClassName={styles.buttonTitle}
                  className={styles.button}
                  title={loading ? "Подождите" : "Отвязать"}
                  onClick={handleDeactivate}
                />
              )}
            </div>
          </div>

          {activeDataGoogleSheets && !isErrorGoogleSheets && (
            <>
              <div className={styles.rowData}>
                <DataItem title={"Ассистент"} data={assistantName} />
                <DataItem
                  title={"Ссылка на таблицу"}
                  data={activeDataGoogleSheets?.link}
                  link={true}
                />
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};
